/**
 * CRO "Jump to" list for pages grouped by design (collection pages and the
 * search results page). The list is server-rendered; this script
 *   - collapses it to two rows with a "Show all (N)" toggle when it is long,
 *   - adds a state page's "More <State> Designs" groups once
 *     cro-collection-filters.js has loaded them (window.CRO.addDesignTocSection),
 *   - scrolls to a #more-… target from the URL once that group exists.
 */
(function () {
  'use strict';

  window.CRO = window.CRO || {};

  function links(nav) {
    return nav.querySelectorAll('.cro-design-toc__link');
  }

  function update(nav) {
    var list = nav.querySelector('.cro-design-toc__list');
    var toggle = nav.querySelector('.cro-design-toc__toggle');
    if (!list || !toggle) return;
    var expanded = nav.classList.contains('is-expanded');
    nav.classList.remove('is-expanded');
    var overflows = list.scrollHeight > list.clientHeight + 2;
    if (expanded) nav.classList.add('is-expanded');
    toggle.hidden = !overflows;
    toggle.textContent = expanded ? 'Show fewer' : 'Show all (' + links(nav).length + ')';
  }

  /* Whole-store pages (data-toc-all): every design of the page's category
     or location type, A–Z, from the location index. A design on this page
     scrolls to its group; any other opens its own page. */
  function fillAllDesigns(nav) {
    var index = window.CRO.locationIndex;
    if (!index) return;
    var cat = nav.getAttribute('data-toc-category') || '';
    var type = nav.getAttribute('data-toc-type') || '';
    var locs = index.filter(function (loc) {
      return (!cat || loc.category === cat) && (!type || loc.type === type);
    });
    /* All products: categories the index has no designs for (Astrology,
       Love Letters) get a link to their page. */
    if (!cat && !type) {
      (nav.getAttribute('data-toc-cats') || '').split(',').forEach(function (c) {
        if (!c || index.some(function (loc) { return loc.category === c; })) return;
        var name = c.replace(/-/g, ' ').replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
        locs.push({ name: name, slug: c, customUrl: '/collections/all/category:' + c });
      });
    }
    locs.sort(function (a, b) { return a.name.localeCompare(b.name); });
    if (!locs.length) return;
    var html = '';
    locs.forEach(function (loc) {
      var onPage = document.getElementById('design-' + loc.slug.toLowerCase());
      var href = onPage ? '#' + onPage.id
        : loc.customUrl || '/collections/all/' + (loc.category ? 'category:' + loc.category + '+' : '') + 'loc-name:' + loc.slug;
      html += '<li><a class="cro-design-toc__link" href="' + escapeHtml(href) + '">' + escapeHtml(loc.name) + '</a></li>';
    });
    nav.querySelector('.cro-design-toc__list').innerHTML = html;
  }

  function setup(nav) {
    if (nav.getAttribute('data-design-toc-ready')) {
      update(nav);
      return;
    }
    nav.setAttribute('data-design-toc-ready', '1');
    if (nav.hasAttribute('data-toc-all')) fillAllDesigns(nav);
    var toggle = nav.querySelector('.cro-design-toc__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        update(nav);
      });
    }
    /* Picking a design from a collapsed list collapses it again */
    nav.addEventListener('click', function (e) {
      if (e.target.closest('.cro-design-toc__link') && nav.classList.contains('is-expanded')) {
        nav.classList.remove('is-expanded');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        update(nav);
      }
    });
    update(nav);
  }

  function initDesignToc(root) {
    var navs = (root || document).querySelectorAll('[data-design-toc]');
    for (var i = 0; i < navs.length; i++) setup(navs[i]);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* groups: [{ id: 'more-berkeley', name: 'Berkeley' }, …] */
  function addDesignTocSection(label, groups) {
    var nav = document.querySelector('[data-design-toc]');
    if (!nav || !groups || !groups.length) return;
    var list = nav.querySelector('.cro-design-toc__list');
    var html = '<li class="cro-design-toc__group-label">' + escapeHtml(label) + '</li>';
    groups.forEach(function (g) {
      html += '<li><a class="cro-design-toc__link" href="#' + escapeHtml(g.id) + '">' + escapeHtml(g.name) + '</a></li>';
    });
    list.insertAdjacentHTML('beforeend', html);
    update(nav);
  }

  /* A state page's list is held open (its space reserved) until the "More"
     groups arrive; afterwards an empty list is hidden. */
  function finishDesignToc() {
    var nav = document.querySelector('[data-design-toc]');
    if (!nav) return;
    nav.classList.remove('cro-design-toc--pending');
    if (!links(nav).length) nav.hidden = true;
    update(nav);

    var hash = window.location.hash;
    if (hash && hash.indexOf('#more-') === 0) {
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) target.scrollIntoView();
    }
  }

  window.CRO.initDesignToc = initDesignToc;
  window.CRO.addDesignTocSection = addDesignTocSection;
  window.CRO.finishDesignToc = finishDesignToc;

  /* -----------------------------------------------------------------------
     Search results page (sections/cro-search-results.liquid)
     ----------------------------------------------------------------------- */

  /* Places, colleges and product types matching the search words, from the
     search box's own matching (window.CRO.searchSuggestions, cro-search.js) */
  function initSearchSuggest() {
    var nav = document.querySelector('[data-search-suggest]');
    if (!nav || !window.CRO.searchSuggestions) return;
    var entries = window.CRO.searchSuggestions(nav.getAttribute('data-query') || '');
    if (!entries.length) return;
    var html = '';
    entries.forEach(function (e) {
      html += '<li><a class="cro-design-toc__link" href="' + escapeHtml(e.url) + '">' + escapeHtml(e.name) + '</a></li>';
    });
    nav.querySelector('ul').innerHTML = html;
    nav.hidden = false;
  }

  /* Product-type buttons: show only that type's results on the page,
     hiding designs (and their Jump to links) left with none. */
  function initTypeFilter() {
    var bar = document.querySelector('[data-type-filter]');
    if (!bar) return;
    var page = bar.closest('[data-search-page]') || document;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-type]');
      if (!btn) return;
      var type = btn.getAttribute('data-type');
      var buttons = bar.querySelectorAll('[data-type]');
      for (var b = 0; b < buttons.length; b++) {
        buttons[b].setAttribute('aria-pressed', buttons[b] === btn ? 'true' : 'false');
      }
      var items = page.querySelectorAll('.cro-grid-item[data-type]');
      for (var i = 0; i < items.length; i++) {
        items[i].hidden = !!type && items[i].getAttribute('data-type') !== type;
      }
      var groups = page.querySelectorAll('.cro-design-group');
      for (var g = 0; g < groups.length; g++) {
        var empty = !groups[g].querySelector('.cro-grid-item:not([hidden])');
        groups[g].hidden = empty;
        var title = groups[g].querySelector('.cro-design-group__title');
        var tocLink = title && page.querySelector('.cro-design-toc__link[href="#' + title.id + '"]');
        if (tocLink) tocLink.parentNode.hidden = empty;
      }
      var nav = page.querySelector('[data-design-toc]');
      if (nav) update(nav);
    });
  }

  initDesignToc();
  initSearchSuggest();
  initTypeFilter();

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { initDesignToc(); }, 150);
  });
})();
